import { jsx } from 'react/jsx-runtime';
import { themeSizeToCssVariable, themeColorToCssVariable } from '../theme/util.js';
import classNames from 'clsx';

/**
 * This is an internal component used for implementation in other DSX components.
 *
 * Please use the `icon` prop in other components, or the `StandaloneIcon` component instead.
 * @private
 */
function UNSAFE_Icon(props) {
  const {
    className: callerClassName,
    icon: Icon,
    color,
    size,
    removeProps = [],
    tag,
    ...rest
  } = props;
  const className = classNames('dsx-component', callerClassName);
  const sizeVar = themeSizeToCssVariable(size);
  const styleProps = {
    color: themeColorToCssVariable(color),
    width: sizeVar,
    height: sizeVar,
    minWidth: sizeVar,
    minHeight: sizeVar
  };
  for (const propToRemove of removeProps) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    delete rest[propToRemove];
  }
  return /*#__PURE__*/jsx(Icon, {
    ...rest,
    className: className,
    "data-dsx--icon": tag,
    style: styleProps
  });
}
/**
 * A StandaloneIcon can be used where there is no further surrounding context for the icon (a table column, for example.)
 *
 * It should NOT be used in a Button, Text, etc. where there is already a prop that provides guided icon settings.
 */
function StandaloneIcon(props) {
  return /*#__PURE__*/jsx(UNSAFE_Icon, {
    ...props
  });
}

export { StandaloneIcon, UNSAFE_Icon };
